'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchRegExp = exports.getNoMatchesOption = exports.getEmptyGroup = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyGroup = void 0;
var getEmptyGroup = exports.getEmptyGroup = function getEmptyGroup() {
  emptyGroup = emptyGroup || {
    disabled: true,
    text: _I18n2.default.text('salesUI.UITypeahead.noOptions'),
    value: '__EMPTY_GROUP__'
  };
  return emptyGroup;
};

var noMatchesOption = void 0;
var getNoMatchesOption = exports.getNoMatchesOption = function getNoMatchesOption() {
  noMatchesOption = noMatchesOption || {
    disabled: true,
    groupIdx: -1,
    text: _I18n2.default.text('salesUI.UITypeahead.noMatchesFound'),
    value: '__EMPTY_OPTION__'
  };
  return noMatchesOption;
};

var getSearchRegExp = exports.getSearchRegExp = function getSearchRegExp(str) {
  return new RegExp(str.trim().replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/typeahead/UITypeaheadUtils.js
// module id = 452
// module chunks = 0